var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.65385C15.2948 7.99753 13.6259 6.83333 11.6793 6.83333C9.095 6.83333 7 8.88536 7 11.4167C7 13.948 9.095 16 11.6793 16C13.1266 16 14.4205 15.3564 15.2788 14.3455M16 9.65385L16 6M16 9.65385L12.7421 9.65385",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/repeat-icon.2ddcedabe0b60bdd94aa8d8add780195.svg";
export { ForwardRef as ReactComponent };